import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const RadioInput = ({ options, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(options[1])

  const handleOptionChange = (event) => {
    const newValue = event.target.value
    setSelectedOption(newValue)
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <div className="frame-radio-input">
      {options.map((option, index) => (
        <div key={index} className="radio-input">
          <label className="container">
            <input
              type="radio"
              name="radio"
              value={option}
              checked={selectedOption === option}
              onChange={handleOptionChange}
            />
            <span className="checkmark"></span>
            <p>{option}</p>
          </label>
        </div>
      ))}
    </div>
  )
}

RadioInput.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func
}

export default RadioInput
